// HOOKS
import { useState } from "react";
import useCreatePermission from "../../../../hooks/users/permissions/useCreate.permission.user.hook";
import useReturnFormComponents from "../../../../hooks/other/useReturnFormComponents";
// COMPONENTS
import DefaultModalForm from "../../defaultModal.form";

const DEFAULT_FORM_FIELDS = {
  name: "",
  description: "",
  notes: "",
  tags: "",
};

const PermissionForm = ({ permission = DEFAULT_FORM_FIELDS }) => {
  const { createPermission, loading } = useCreatePermission();
  const { getFormComponents } = useReturnFormComponents();
  const [isLoading, setIsLoading] = useState(false);
  const [formFields, setFormFields] = useState(permission);
  const { name, description, notes, tags } = formFields;
  const handleSave = async (event) => {
    event.preventDefault();
    try {
      if (isLoading) return;
      if (!name) return alert("Name is required");
      setIsLoading(true);
      const permission = await createPermission(formFields);
      if (!permission?.name) throw new Error("Failed to create permission");
      alert(`Created Permission: ${permission?.name}`);
      setFormFields(DEFAULT_FORM_FIELDS);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log({ error });
      alert(error.message);
    }
  };
  const handleChange = (event) => {
    event.preventDefault();
    setFormFields({ ...formFields, [event.target.name]: event.target.value });
  };
  const FORM_FIELDS = [
    {
      type: "text",
      props: {
        label: "Name",
        value: name,
        name: "name",
        onChange: handleChange,
        className: "w-96",
      },
    },
    {
      type: "text",
      props: {
        label: "Description",
        value: description,
        name: "description",
        onChange: handleChange,
        className: "w-96",
      },
    },
    {
      type: "text",
      props: {
        label: "Notes",
        value: notes,
        name: "notes",
        onChange: handleChange,
        className: "w-96",
      },
    },
    {
      type: "text",
      props: {
        label: "Tags",
        value: tags,
        name: "tags",
        onChange: handleChange,
        className: "w-96",
        help: {
          text: "Add tags to help categorize this permission, and use commas to separate tags.",
        },
      },
    },
  ];
  return (
    <DefaultModalForm
      header="Create Permissions"
      handleClick={handleSave}
      loading={isLoading}
      saveButton={{ handleClick: handleSave, loading: isLoading }}
    >
      {getFormComponents({ fields: FORM_FIELDS })}
    </DefaultModalForm>
  );
};

export default PermissionForm;
